import { Divider, InputAdornment } from '@material-ui/core';
import React from 'react';
import type { ReactNode } from 'react';

import styles from './styles';

type InputAdornmentProps = {
  children: ReactNode;
  classes: any;
};

const Prefix = ({ children, classes }: InputAdornmentProps) => {
  return (
    <InputAdornment position='start' className={classes.inputPrefixClass}>
      {children}
      <Divider orientation='vertical' />
    </InputAdornment>
  );
};

export default styles(Prefix);
